import React, { createContext, useEffect, useState } from 'react'
import "../App.css";
import { getUser, getLottery } from '../services/userServices';


export const UserContext = createContext();

export const UserProvider = ({ children}) => {
    const [isLogin, setIsLogin] = useState(false);
    const [captcha, setCaptcha] = useState(false);
    const [userId, setUserId] = useState(null);
    const [userData, setUserData] = useState(null);
    const [lotteryData, setLotteryData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Parse ID from URL: last non-empty segment
    useEffect(() => {
        const segments = window.location.pathname.split('/').filter(Boolean);
        let idSegment = null;
        
        // Check if we have an ID in the URL (before /admin if present)
        if (segments.length >= 1) {
            // If last segment is 'admin', get the previous one as ID
            if (segments[segments.length - 1].toLowerCase() === 'admin' && segments.length >= 2) {
                idSegment = segments[segments.length - 2];
                console.log('Admin route detected, ID segment:', idSegment);
            } else {
                // Otherwise, last segment is the ID
                idSegment = segments[segments.length - 1];
                console.log('Regular route, ID segment:', idSegment);
            }
        }
        
        // Set userId if we have a valid ID segment
        if (idSegment && idSegment.toLowerCase() !== 'admin') {
            console.log('Setting userId to:', idSegment);
            setUserId(idSegment);
            setError('');
        } else if (!idSegment) {
            console.log('No valid ID segment found');
            setUserId(null);
            setError('');
        }
        // If we're on admin route, keep existing userId
    }, [window.location.pathname]);

    // Fetch user and lottery when userId is available
    useEffect(() => {
        const fetchAll = async () => {
            if (!userId) return;
            console.log('Fetching data for userId:', userId);
            setLoading(true);
            setError('');
            try {
                const [u, lRaw] = await Promise.all([
                    getUser(userId),
                    getLottery(userId)
                ]);
                // Sort lotteries by latest id descending so newest appears first
                let l = lRaw;
                try {
                    if (Array.isArray(lRaw)) {
                        l = [...lRaw].sort((a, b) => (b?.id ?? 0) - (a?.id ?? 0));
                    } else if (lRaw && Array.isArray(lRaw.data)) {
                        l = { ...lRaw, data: [...lRaw.data].sort((a, b) => (b?.id ?? 0) - (a?.id ?? 0)) };
                    }
                } catch {}
                console.log('User data fetched:', u);
                console.log('Lottery data fetched (sorted):', l);
                setUserData(u);
                setLotteryData(l);
            } catch (e) {
                console.error('UserContext fetch error', e);
                const serverMessage = e?.response?.data?.message || e?.response?.data?.error || e?.message || '';
                setError(serverMessage);
            } finally {
                setLoading(false);
            }
        };
        fetchAll();
    }, [userId]);

    return (
        <UserContext.Provider value={{
            isLogin, setIsLogin,
            captcha, setCaptcha,
            userId, userData, lotteryData,
            loading, error
        }}>
            {children}
        </UserContext.Provider>
    );

};
